
let observer;
document.addEventListener("DOMContentLoaded", function () {
  applyDiscountLogic();

  // Reapply on variant change
  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id") {
      setTimeout(applyDiscountLogic, 50);
    }
  });

  const priceContainer = document.querySelector("#ProductPrice, .product-single__price");

  function setupObserver() {
    if (priceContainer) {
      observer = new MutationObserver(function () {
        console.log("🔁 Price mutated (likely currency change)");
        setTimeout(applyDiscountLogic, 50);
      });
      observer.observe(priceContainer, { childList: true, subtree: true });
    }
  }

  setupObserver();

  function applyDiscountLogic() {
    const discountCode = getCookie("_gap_discount");

    const cartCurrency = getCookie("cart_currency") || "USD";
    console.log(`🌍 Detected cart_currency cookie: ${cartCurrency}`);

    const discountMap = {
      "SAVE15": 15,
      "THANKYOU20": 20,
      "WELCOME15": 15,
      "SOLO25": 25,
      "TAKE15OFF": 15,
      "SAVE20": 20,
      "GYPSY20": 20,
      "DANKE20": 20,
      "MERCI20": 20,
      "GRAZIE20": 20,
      "GRACIAS20": 20,
      "GAPSAVE15": 15,
      "SHARON20": 20,
      "BEDANKT20": 20,
      "TACK20": 20,
      "EWTHANKS20": 20
    };

    if (!discountCode || !(discountCode.toUpperCase() in discountMap)) {
      console.log("🚫 No valid discount code in cookie");
      return;
    }

    const discountPercent = discountMap[discountCode.toUpperCase()];
    const discountRate = discountPercent / 100;
    console.log(`✅ Applying discount: ${discountCode} = ${discountPercent}%`);

    
    let priceEl = document.querySelector(".product-single__price .money, .price .money");
    if (!priceEl) {
      // Fallback: use outer price container directly if .money is missing
      priceEl = document.querySelector("#ProductPrice, .product-single__price, .price");
    }
    if (!priceEl) {
      console.warn("⚠️ .money price element not found");
      return;
    }

    const rawText = priceEl.innerText.trim();
    let originalPrice, discountedPrice, formattedOriginal, formattedDiscount;

    switch (cartCurrency) {
      case "GBP":
        originalPrice = parseFloat(rawText.replace("£", ""));
        discountedPrice = (originalPrice * (1 - discountRate)).toFixed(2);
        formattedOriginal = `£${originalPrice.toFixed(2)}`;
        formattedDiscount = `£${discountedPrice}`;
        break;

      case "EUR":
        originalPrice = parseFloat(rawText.replace("€", "").replace(",", "."));
        discountedPrice = (originalPrice * (1 - discountRate)).toFixed(2);
        formattedOriginal = `€${originalPrice.toFixed(2).replace(".", ",")}`;
        formattedDiscount = `€${discountedPrice.replace(".", ",")}`;
        break;

      case "KR":
      case "SEK":
        originalPrice = parseFloat(rawText.replace("Kr", "").trim());
        discountedPrice = (originalPrice * (1 - discountRate)).toFixed(0);
        formattedOriginal = `${originalPrice.toFixed(2)} Kr`;
        formattedDiscount = `${parseFloat(discountedPrice).toFixed(2)} Kr`;
        break;

      case "CAD":
      case "AUD":
      case "USD":
      default:
        originalPrice = parseFloat(rawText.replace(/[^0-9.]/g, ""));
        discountedPrice = (originalPrice * (1 - discountRate)).toFixed(2);
        formattedOriginal = `$${originalPrice.toFixed(2)}`;
        formattedDiscount = `$${discountedPrice}`;
        break;
    }

    if (observer) observer.disconnect();

    priceEl.innerHTML = `<span style="text-decoration: line-through; color: gray;">${formattedOriginal}</span> <span style="color: green; font-weight: bold;">${formattedDiscount}</span>`;
    console.log(`💰 Price changed from ${formattedOriginal} to ${formattedDiscount}`);

    const existingMsg = document.querySelector(".gap-discount-message");
    if (existingMsg) existingMsg.remove();

    const lang = document.body.dataset.lang || "en";
    const messages = {
      en: `🎉 ${discountCode.toUpperCase()} applied: ${discountPercent}% off`,
      de: `🎉 ${discountCode.toUpperCase()} angewendet: ${discountPercent}% Rabatt`,
      fr: `🎉 ${discountCode.toUpperCase()} appliqué : ${discountPercent}% de réduction`,
      es: `🎉 ${discountCode.toUpperCase()} aplicado: ${discountPercent}% de descuento`,
      it: `🎉 ${discountCode.toUpperCase()} applicato: sconto del ${discountPercent}%`,
      nl: `🎉 ${discountCode.toUpperCase()} toegepast: ${discountPercent}% korting`,
      sv: `🎉 ${discountCode.toUpperCase()} aktiverat: ${discountPercent}% rabatt`
    };

    const messageText = messages[lang] || messages["en"];

    const msg = document.createElement("div");
    msg.className = "gap-discount-message";
    msg.innerText = messageText;
    msg.style.color = "green";
    msg.style.fontWeight = "bold";
    msg.style.marginTop = "10px";
    priceEl.parentNode.parentNode.insertBefore(msg, priceEl.parentNode.nextSibling);

    if (observer && priceContainer) observer.observe(priceContainer, { childList: true, subtree: true });
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        console.log(`✅ Found cookie ${name}:`, decodeURIComponent(c.substring(nameEQ.length)));
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    console.log("❌ Cookie not found:", name);
    return null;
  }
});
